// Components
import { ModalUpsell } from '@/components/composite/Modals/ModalUpsell';
import LayoutLogged from '@/components/layouts/LayoutLogged';
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
import ConversationsTabs from '@/components/pages/manage/ConversationsTabs';

// Hooks
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useToggle from '@/utils/hooks/utils/useToggle';

// Types
import useTranslation from 'next-translate/useTranslation';

export const HeaderConversations = ({ unreadComments = undefined, unreadMentions = undefined }) => {
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const { activeGroup } = useActiveGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { t: tCommons } = useTranslation('commons');
    const { isOpen, toggle } = useToggle();

    const getPageTitle = () => {
        if (!activeSocialProfile?.id && activeGroup) {
            return tCommons('menu.group_conversations');
        }

        return tCommons('menu.conversations');
    };

    if (!isTreeStructureActivated) {
        return (
            <LayoutLogged.Header
                className="scrollbar overflow-x-auto px-1"
                data-testid="header-conversations">
                <ConversationsTabs
                    unreadComments={unreadComments}
                    unreadMentions={unreadMentions}
                />
            </LayoutLogged.Header>
        );
    }

    return (
        <>
            <PageHeaderRecap title={getPageTitle()} />
            <ModalUpsell
                heading={tCommons('upsell_modal.mentions.heading')}
                description={tCommons('upsell_modal.mentions.description')}
                benefits={[
                    { text: tCommons('upsell_modal.mentions.benefit1'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit2'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit3'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit4'), icon: 'plus' }
                ]}
                illustrationPath="/images/modals/modalUpsell/mention.png"
                dismiss={toggle}
                isOpen={isOpen}
            />
        </>
    );
};
